module.exports = __webpack_public_path__ + "img/ditto.e9eaa8a0.svg";